import React from 'react'

// App components
import InfusionsoftForm from '../components/InfusionsoftForm'
import { styles as buttonStyles } from '../components/Button'

// App utils
import { getRecaptchaId } from '../utils/formsConfig'
import { rhythm } from '../utils/typography'
import { themeStyles, colors, metrics, presets } from '../utils/theme'

const styles = {
  form: {
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${colors.lightGrey}`,
    padding: rhythm(1),
    width: '100%',
    marginTop: 0,
    marginBottom: 0,
    maxWidth: '700px',
    minWidth: '300px',
    backgroundColor: 'white',
    [presets.Tablet]: {
      minWidth: '400px',
    },
    flex: 1,
    ...themeStyles.shadow,
  },
  input: {
    padding: rhythm(1 / 2),
    marginBottom: rhythm(1 / 2),
    color: '#787878',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'stretch',
    flexWrap: 'wrap',
    marginTop: metrics.defaultMargin,
    marginBottom: metrics.defaultMargin,
    ...themeStyles.textPadding,
  },
  buttonSubmit: {
    width: '100%',
    marginTop: rhythm(1),
    border: `2px solid white`,
    borderRadius: '3px',
    padding: '10px',
    fontSize: rhythm(1),
    fontFamily: 'sans-serif',
    fontWeight: '100',
    color: 'white',
    display: 'flex',
    flexDirection: 'row',
    flex: -1,
    transition: 'all 0.3s ease',
    backgroundColor: colors.brightBlue,
    textDecoration: 'none',
    ...themeStyles.shadow,
    ':hover': {
      color: 'white',
      backgroundColor: colors.brightBlue,
    },
  },
  collinsText: {
    fontSize: '12px',
    color: '#53d2e7',
    marginBottom: '20px',
  },
}

export class FreeConsultForm extends React.Component {
  state = {
    dateTouched: false,
  }

  onFocusDate = () => {
    this.setState({ dateTouched: true })
  }

  render() {
    return (
      <InfusionsoftForm
        id="request-appointment-form"
        css={styles.form}
        configKey="requestAppointment"
      >
        <input
          css={styles.input}
          id="inf_field_FirstName"
          name="inf_field_FirstName"
          placeholder="First Name"
          type="text"
          required
        />
        <input
          css={styles.input}
          id="inf_field_LastName"
          name="inf_field_LastName"
          placeholder="Last Name"
          type="text"
          required
        />
        <input
          css={styles.input}
          onFocus={this.onFocusDate}
          id="inf_field_Birthday"
          name="inf_field_Birthday"
          placeholder="Date of Birth"
          type={this.state.dateTouched ? 'date' : 'text'}
          required
        />
        <input
          css={styles.input}
          id="inf_custom_ResponsibleParty"
          name="inf_custom_ResponsibleParty"
          placeholder="Responsible Party"
          type="text"
          required
        />
        <input
          css={styles.input}
          id="inf_field_Phone1"
          name="inf_field_Phone1"
          placeholder="Contact Phone"
          type="phone"
          required
        />
        <input
          css={styles.input}
          id="inf_field_Email"
          name="inf_field_Email"
          placeholder="Contact Email"
          type="email"
          required
        />
        <input
          css={styles.input}
          id="inf_custom_Message"
          name="inf_custom_Message"
          placeholder="Why are you seeking a consultation at our office?"
          type="text"
        />

        <div id="patient-panorex-or-xray-content">
          If patient has recent panorex or x-rays, please email to{' '}
          <a href="mailto:info@rochesterorthodontics.com">
            info@rochesterorthodontics.com
          </a>
        </div>
        <br />

        <div css={styles.collinsText}>
          <i>
            Collins Orthodontics will attempt to reach out via phone, text
            and/or email to schedule an appointment.
            <br />
            Patients may update their preferred communication method at that
            time.
          </i>
        </div>

        {/* <div>
          <label for="textOptIn">Is it okay to contact by text message?</label>
          <br />
          <select id="textOptIn" name="textOptIn">
            <option value="no">No</option>
            <option value="yes">Yes</option>
          </select>
        </div> */}

        <div>
          <button
            css={styles.buttonSubmit}
            id={getRecaptchaId('requestAppointment')}
            type="submit"
          >
            Submit
          </button>
        </div>
      </InfusionsoftForm>
    )
  }
}
